import { searchAssets, useUserContext } from "@dexteel/mesf-core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTemplatesContext } from "../context/templatesContext";

export const useInitializeTemplate = () => {
	const navigate = useNavigate();
	const [filtersLoaded, setFiltersLoaded] = useState(false);
	const {
		state: { defaultAreaId },
	} = useUserContext();

	const { data: allAssets } = searchAssets();

	const { actions } = useTemplatesContext();

	const params = useParams();

	useEffect(() => {
		if (allAssets && allAssets.length) {
			setFiltersLoaded(true);
		}
	}, [allAssets]);

	useEffect(() => {
		if (filtersLoaded) {
			if (params.AssetIdParam) {
				actions.setSearchAssetIdToTable(params.AssetIdParam);
				actions.setSearchAssetName(
					allAssets?.find(
						(asset) => asset.AssetId === Number.parseInt(params.AssetIdParam!),
					)?.AssetName || "Unknown",
				);
			}
		}
	}, [JSON.stringify(params), filtersLoaded]);
};
